import React from 'react';
import _ from 'lodash';
import Item from './item';
import cx from 'classnames';

class Group extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showChildren: false,
    };
  }

  /**
   * Returns the currently selected children
   * @returns {Array}
   */
  selectedChildren() {
    return _.select(this.props.group.children, {
      selected: true,
    });
  }

  /**
   * Does the group have any selected children?
   * @returns {boolean}
   */
  anyChildrenSelected = () => this.props.group.children.some(c => c.selected);

  /**
   * Are all the group's children selected?
   * @returns {boolean}
   */
  allChildrenSelected = () => this.props.group.children.every(c => c.selected);

  /**
   * Toggle the display of the children
   */
  toggleChildrenDisplay = () => {
    this.setState(prevState => ({ showChildren: !prevState.showChildren }));
  };

  /**
   * Toggle all chilrens' selected state.
   * @param event
   */
  toggleSelectedChildren = event => {
    event.preventDefault();
    event.stopPropagation();
    var newValue = !this.allChildrenSelected();
    this.props.toggleItems(this.props.group.children, newValue);
  };

  componentDidMount() {
    this.setState({ showChildren: this.anyChildrenSelected() });
  }

  children() {
    if (this.state.showChildren) {
      return this.props.group.children.map(
        function(item, index) {
          return (
            <Item
              className="child"
              item={item}
              toggle={this.props.toggleItems}
              key={index}
              showTooltipDescription={this.props.showTooltipDescriptions}
            />
          );
        }.bind(this),
      );
    }
  }

  // improved subscription flow feature includes an update to the check all / uncheck all text
  checkAllText() {
    return this.props.improvedSubFlow ? 'Select all' : 'Check all';
  }

  uncheckAllText() {
    return this.props.improvedSubFlow ? 'Clear' : 'Uncheck all';
  }

  render() {
    var classes = ['grouped-item', 'border-color', 'group-parent'];
    const active = this.anyChildrenSelected();

    if (this.state.showChildren) {
      classes.push('open');
    }

    if (active) {
      classes.push('active');
    }

    return (
      <div>
        <div className={cx(classes)}>
          <i
            className={cx(
              'color-secondary',
              'fa',
              'show-children',
              this.state.showChildren ? 'fa-minus' : 'fa-plus',
            )}
            onClick={this.toggleChildrenDisplay}
          />
          <span>{this.props.group.name}</span>
          <i
            className="fa fa-ellipsis-v children-selected"
            style={{ display: active ? null : 'none' }}
          />
          <a
            className="toggle-children pull-right"
            tabIndex={0}
            onClick={this.toggleSelectedChildren}
          >
            {!this.allChildrenSelected()
              ? this.checkAllText()
              : this.uncheckAllText()}
          </a>
        </div>
        {this.children()}
      </div>
    );
  }
}

export default Group;
